import { render, staticRenderFns } from "./trend.vue?vue&type=template&id=49eac7c0&scoped=true&"
import script from "./trend.vue?vue&type=script&lang=js&"
export * from "./trend.vue?vue&type=script&lang=js&"
import style0 from "./trend.vue?vue&type=style&index=0&id=49eac7c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49eac7c0",
  null
  
)

export default component.exports